import {XYPosition} from 'reactflow';
import {v4 as uuidv4} from 'uuid';

import {assert} from 'Asserts';

import {generateLogicNodeIdentifier} from '../flowchartIdentifierUtils';
import {ProcessFlowchartNodeType} from '../processFlowchartConfigEditorConstants';
import {FlowchartNode, StaticDataForNodeType} from '../processFlowchartConfigEditorNodeTypes';
import {
  createEndNodeStaticData,
  createStaticNodeDataFromRouterConfig,
  FlowchartOptions,
} from '../processFlowchartConfigEditorUtils';
import {getNodeTypeToCreateNodeFunction} from './sidepanelNodeUtils';

export function getLogicNodeCreationContext(
  nodeType: ProcessFlowchartNodeType
): StaticDataForNodeType<typeof nodeType> {
  if (nodeType === ProcessFlowchartNodeType.ROUTER_NODE) {
    return createStaticNodeDataFromRouterConfig(generateLogicNodeIdentifier(nodeType), {
      clientId: uuidv4(),
      name: 'Router',
      defaultFunctionSpec: null,
      functionSpecs: [],
    });
  } else if (nodeType === ProcessFlowchartNodeType.STOP_NODE) {
    return createEndNodeStaticData(generateLogicNodeIdentifier(nodeType), 'Stop');
  }
  assert(false, `Unsupported node type: ${nodeType}`);
}

export function getNewLogicNode(
  staticData: StaticDataForNodeType<ProcessFlowchartNodeType>,
  position: XYPosition,
  options: FlowchartOptions
): FlowchartNode {
  const nodeCreatorFn = getNodeTypeToCreateNodeFunction()[staticData.nodeType] as (
    staticData: StaticDataForNodeType<ProcessFlowchartNodeType>,
    position: XYPosition,
    options: FlowchartOptions
  ) => FlowchartNode;

  // We need to generate a new ID for the node so that every new node of the same type has a unique ID.
  return nodeCreatorFn({...staticData, id: uuidv4()}, position, options);
}

export function getCreateLogicNodeName(nodeType: ProcessFlowchartNodeType): string {
  if (nodeType === ProcessFlowchartNodeType.ROUTER_NODE) {
    return 'Router';
  } else if (nodeType === ProcessFlowchartNodeType.STOP_NODE) {
    return 'Stop';
  }
  assert(false, `Unsupported node type: ${nodeType}`);
  return '';
}
